<template>
	<v-container fluid style="max-width: 500px;"> 
		<UserDialog ref="user" @show-alert="(payload) => doShowAlert(payload)" @refresh="$emit('refresh')" />
		<ConfigDialog ref="config" @show-alert="(payload) => doShowAlert(payload)" @refresh="$emit('refresh')" />
		<AssessmentDialog ref="assessment" @show-alert="(payload) => doShowAlert(payload)" @refresh="$emit('refresh')" />
				
		<v-snackbar
			v-model="showAlert"
			:timeout="alertTimeout"
			:color="alertColor">
				<span style="color: #ffffff;">{{ alertText }}</span>
				<v-btn text @click="showAlert=false">
				<span style="color: #ffffff;">{{ $t('common.dialog-buttons.close') }}</span>
				</v-btn>
		</v-snackbar>
	</v-container>
</template>
 
<script> 
import UserDialog from "../dialogs/UserDialog";
import ConfigDialog from "../dialogs/ConfigDialog";
import AssessmentDialog from "../dialogs/AssessmentDialog";
 
export default {
	name: 'DialogManager',
	components: { 
		UserDialog, ConfigDialog, AssessmentDialog
	},   
	data() {
		return {
			showAlert: false,
			alertColor: 'error',
			alertText: '',
			alertTimeout: 6000
		}
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    processEvent(mode, type, action, payload) {
      this.$refs[type.toLowerCase()].open(action, payload);
    },
    doShowAlert (payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
    },
  }
}
</script>